'use es6';

import MobileUAParts from './parts/MobileUAParts';

// Grabbed from https://gist.github.com/dalethedeveloper/1503252
const MOBILE_UA_REGEX = new RegExp(`Mobile|${MobileUAParts.ios}|${MobileUAParts.android}|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune`);
export default MOBILE_UA_REGEX;